'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _reactRouter = require('react-router');

var _components = require('components');

var _notification = require('redux/modules/notification');

var notificationActions = _interopRequireWildcard(_notification);

var _voucher = require('redux/modules/voucher');

var vouchersAction = _interopRequireWildcard(_voucher);

var _NotificationMobile = require('./NotificationMobile.scss');

var styles = _interopRequireWildcard(_NotificationMobile);

var _localStorage = require('utils/localStorage');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Images = {
  promotion: require('../../../assets/img/notification/promotion.png'),
  booking_sent: require('../../../assets/img/notification/booking_sent.png'),
  booking_accepted: require('../../../assets/img/notification/booking_accepted.png'),
  booking_rejected: require('../../../assets/img/notification/booking_rejected.png'),
  booking_reminder: require('../../../assets/img/notification/booking_reminder.png'),
  booking_complete: require('../../../assets/img/notification/booking_complete.png'),
  new_place_created: require('../../../assets/img/notification/new_place_created.png'),
  new_place_rejected: require('../../../assets/img/notification/new_place_rejected.png'),
  user_promoted: require('../../../assets/img/notification/user_promoted.png'),
  notification_placeholder: require('../../../assets/img/notification/notification_placeholder.png'),
  announcement: require('../../../assets/img/notification/announcement.png'),
  voucherNoti: require('../../../assets/img/notification/voucherNoti.png'),
  cancelIcon: require('../../../assets/img/notification/cancelIcon.png'),
  reward_point: require('../../../assets/img/notification/plusIcon.png')
};
var NotificationMobile = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    notifications: state.notification.notifications,
    MY_REWARD_LIST: state.voucher.MY_REWARD_LIST
  };
}, (0, _extends3.default)({}, authActions, notificationActions, vouchersAction)), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(NotificationMobile, _Component);

  function NotificationMobile(props) {
    (0, _classCallCheck3.default)(this, NotificationMobile);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NotificationMobile.__proto__ || (0, _getPrototypeOf2.default)(NotificationMobile)).call(this, props));

    _this.openDialog = function (data) {
      _this.setState({
        dialog: !false,
        text: data
      });
    };

    var initialState = {
      success: false,
      dialog: false,
      text: '',
      hasBanner: true
    };

    // Check if banner is hidden for today
    var bannerHiddenDate = (0, _localStorage.localStore)().get('notiBannerHiddenDate');
    if (bannerHiddenDate) {
      var now = (0, _moment2.default)().format('YYYY-MM-DD');
      if (now === bannerHiddenDate) {
        initialState.hasBanner = false;
      }
    }
    _this.state = initialState;

    _this.openDialog = _this.openDialog.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(NotificationMobile, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.loadNotification();
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.getMyReward();
    }
  }, {
    key: 'onHandleNotification',
    value: function onHandleNotification(data) {
      this.props.readOne(data._id);
      switch (data.data.type) {
        case 'announcement':
          if (data.data.contentType === 'url') {
            window.open(data.data.url, '_blank');
            window.focus();
          } else if (data.data.contentType === 'text') {
            this.openDialog(data.data.text);
          }
          break;
        case 'promotion':
          if (data.data.voucherID) {
            _reactRouter.browserHistory.push('voucher-detail/' + data.data.voucherID);
          } else _reactRouter.browserHistory.push('uu-dai');
          break;
        case 'booking_accepted':
        case 'booking_rejected':
        case 'booking_reminder':
        case 'booking_complete':
          _reactRouter.browserHistory.push('lich-hen/' + data.data.bookingRequestId);
          break;
        case 'new_place_created':
        case 'new_place_rejected':
          _reactRouter.browserHistory.push('' + data.data.shopId);
          break;
        case 'user_promoted':
          window.open(data.data.merchantAppUrl, '_blank');
          window.focus();
          break;
        default:
          break;
      }
    }
  }, {
    key: 'onClose',
    value: function onClose() {
      this.setState({
        dialog: false
      });
    }
  }, {
    key: 'useVoucher',
    value: function useVoucher() {
      this.props.changeTab('myReward');
    }
  }, {
    key: 'onCancel',
    value: function onCancel() {
      this.setState({ hasBanner: false });
      var dateNow = (0, _moment2.default)().format('YYYY-MM-DD');
      (0, _localStorage.localStore)().set('notiBannerHiddenDate', dateNow);
    }
  }, {
    key: 'renderTime',
    value: function renderTime(time) {
      _moment2.default.locale('vi');
      return (0, _moment2.default)(time).fromNow();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          notifications = _props.notifications,
          MY_REWARD_LIST = _props.MY_REWARD_LIST;
      var hasBanner = this.state.hasBanner;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _components.ModalCustom,
          {
            show: this.state.dialog,
            closeButton: true,
            onHide: function onHide() {
              return _this2.onClose();
            }
          },
          _react2.default.createElement(
            'div',
            { className: styles.dialog },
            this.state.text
          )
        ),
        notifications && notifications.length > 0 && hasBanner ? _react2.default.createElement(
          'div',
          { className: styles.voucherView },
          _react2.default.createElement('img', { src: Images.voucherNoti, className: styles.voucherImage }),
          _react2.default.createElement(
            'div',
            { className: styles.textNotiView },
            _react2.default.createElement(
              'div',
              { className: styles.voucherText },
              'B\u1EA1n \u0111ang c\xF3 ',
              MY_REWARD_LIST.number || 0,
              ' vouchers ch\u01B0a s\u1EED d\u1EE5ng n\xE8!'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.useNow, onClick: function onClick() {
                return _this2.useVoucher();
              } },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/uu-dai' },
              _react2.default.createElement(
                'div',
                { className: styles.useNowText },
                'S\u1EED d\u1EE5ng ngay!'
              )
            )
          ),
          _react2.default.createElement('img', {
            src: Images.cancelIcon,
            className: styles.cancelIcon,
            onClick: function onClick() {
              return _this2.onCancel();
            }
          })
        ) : null,
        notifications && notifications.length > 0 ? notifications.map(function (value) {
          return _react2.default.createElement(
            'div',
            { className: styles.notiView },
            value.title && value.title.length > 0 && value.body && value.body.length > 0 ? _react2.default.createElement(
              'div',
              {
                className: styles.data,
                onClick: function onClick() {
                  return _this2.onHandleNotification(value);
                }
              },
              _react2.default.createElement(
                'div',
                { className: styles.firstView },
                _react2.default.createElement('img', { src: Images[value.data.type], style: { height: 20 } })
              ),
              _react2.default.createElement(
                'div',
                { className: styles.secondView },
                _react2.default.createElement(
                  'div',
                  { className: styles.textView },
                  _react2.default.createElement(
                    'div',
                    { className: styles.title },
                    value.title
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.body },
                    value.body
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.time },
                    _this2.renderTime(value.createdAt)
                  )
                ),
                !value.read ? _react2.default.createElement('div', { className: styles.circle }) : null
              )
            ) : null
          );
        }) : _react2.default.createElement(
          'div',
          { className: styles.emptyNotificationView },
          _react2.default.createElement('img', {
            src: Images.notification_placeholder,
            style: { height: 211, width: 264, marginBottom: 23 }
          }),
          _react2.default.createElement(
            'div',
            { className: styles.placeholderText },
            'Ch\u01B0a c\xF3 th\xF4ng b\xE1o!'
          )
        )
      );
    }
  }]);
  return NotificationMobile;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  notifications: _react.PropTypes.array,
  MY_REWARD_LIST: _react.PropTypes.object,
  loadNotification: _react.PropTypes.func.isRequired,
  readOne: _react.PropTypes.func,
  getMyReward: _react.PropTypes.func,
  changeTab: _react.PropTypes.func
}, _temp)) || _class);
exports.default = NotificationMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Notification/NotificationMobile.js
// module id = 1617
// module chunks = 0